/* vd-shim.js - comportements du theme copie de verudia.com.
   Remplace le JS sous licence de Shrine PRO (non repris) par une implementation maison minimale.
   Dawn (global.js, details-modal.js, predictive-search.js...) fournit le reste. */
(function () {
  'use strict';

  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }
  function money(cents) {
    var fmt = (window.vdMoneyFormat || '{{amount}}');
    var v = (Number(cents) / 100);
    var withComma = function (n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? p[0] + ds + p[1] : p[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withComma(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withComma(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withComma(v, 0, '.', ',');
      if (k === 'amount_no_decimals_with_space_separator') return withComma(v, 0, ' ', ',');
      if (k === 'amount_with_space_separator') return withComma(v, 2, ' ', ',');
      return withComma(v, 2, ',', '.');
    });
  }

  /* ---------- en-tete collant (equivalent sticky-group-manager "always") ---------- */
  define('sticky-group-manager', class extends HTMLElement {
    connectedCallback() {
      var header = this.querySelector('sticky-header');
      if (!header) return;
      var type = header.dataset.stickyType || 'none';
      if (type === 'none') return;
      var section = header.closest('.section-header') || header.parentElement;
      section.classList.add('shopify-section-header-sticky');
      var update = function () {
        var h = Math.ceil(section.getBoundingClientRect().height);
        section.style.setProperty('--header-height', h + 'px');
        document.documentElement.style.setProperty('--header-height', h + 'px');
        document.documentElement.style.setProperty('--sticky-group-height', h + 'px');
      };
      update();
      new ResizeObserver(update).observe(section);
      window.addEventListener('scroll', function () {
        section.classList.toggle('scrolled-past-header', window.scrollY > 0);
      }, { passive: true });
    }
  });
  define('sticky-header', class extends HTMLElement {});

  /* ---------- carrousels Splide ---------- */
  define('splide-component', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var start = function () {
        if (self._splide || !window.Splide) return;
        var el = self.querySelector('.splide');
        if (!el) return;
        var d = self.dataset;
        var int = function (v, def) { var n = parseInt(v, 10); return isNaN(n) ? def : n; };
        var type = d.type || 'slide';
        var padCalcD = d.paddingCalcDesktop === 'true', padCalcM = d.paddingCalcMobile === 'true';
        var rD = int(d.sidePaddingDesktop, 0), rM = int(d.sidePaddingMobile, 0);
        var cfg = {
          type: type, rewind: type === 'fade', autoplay: d.autoplay === 'true',
          interval: int(d.autoplaySpeed, 5) * 1000, arrows: d.arrows !== 'false', pagination: d.pagination !== 'false',
          omitEnd: d.omitEnd !== 'false', perPage: int(d.slidesDesktop, 3), perMove: int(d.perMoveDesktop, 1),
          gap: int(d.gapDesktop, 30), padding: { left: padCalcD ? 0 : rD, right: rD }, destroy: d.destroyDesktop === 'true',
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          classes: { arrow: 'splide__arrow' + (d.arrowsColor ? ' color-' + d.arrowsColor : ''), page: 'splide__pagination__page' + (d.dotsColor ? ' color-' + d.dotsColor + ' dots-custom-color' : '') },
          breakpoints: { 749: { type: d.typeMobile || type, perPage: int(d.slidesMobile, 1), perMove: int(d.perMoveMobile, 1), gap: int(d.gapMobile, 15), padding: { left: padCalcM ? 0 : rM, right: rM }, destroy: d.destroyMobile === 'true' } }
        };
        try { self._splide = new window.Splide(el, cfg).mount(); } catch (e) { console.warn('vd splide', e); }
      };
      if (window.Splide) start(); else window.addEventListener('load', start);
    }
  });

  /* ---------- onglets de contenu ---------- */
  define('content-tabs', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.activeClass = this.dataset.productTabs === 'true' ? 'active' : 'content-tab-button--active';
      this.buttons = this.querySelectorAll('.content-tab-button-js');
      this.tabs = this.querySelectorAll('.content-tab');
      this.box = this.querySelector('.content-tabs__tabs-js');
      this.bg = this.dataset.animation === 'moving' ? this.querySelector('.content-tab-buttom__active-bg') : null;
      this.btn = this.querySelector('.' + this.activeClass) || this.buttons[0];
      this.tab = this.querySelector('.content-tab--active') || this.tabs[0];
      this.buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          self.btn = b;
          self.buttons.forEach(function (x) { x.classList.remove(self.activeClass); });
          b.classList.add(self.activeClass);
          self.tabs.forEach(function (t) { t.classList.toggle('content-tab--active', t.dataset.index === b.dataset.index); if (t.dataset.index === b.dataset.index) self.tab = t; });
          self.layout();
        });
      });
      window.addEventListener('resize', function () { self.layout(); });
      setTimeout(function () { self.layout(); }, 50);
      window.addEventListener('load', function () { self.layout(); });
    }
    layout() {
      if (this.tab && this.box) this.box.style.height = this.tab.clientHeight + 'px';
      if (this.bg && this.btn) {
        var r = this.btn.getBoundingClientRect();
        this.bg.style.transitionDuration = '0.4s';
        this.bg.style.width = r.width + 'px'; this.bg.style.height = r.height + 'px';
        this.bg.style.top = this.btn.offsetTop + 'px'; this.bg.style.left = this.btn.offsetLeft + 'px';
      }
    }
  });

  /* ---------- dates de livraison ---------- */
  define('dynamic-dates', class extends HTMLElement {
    connectedCallback() {
      var days = (this.dataset.dayLabels || 'Mon, Tue, Wed, Thu, Fri, Sat, Sun').split(/,\s*/);
      var months = (this.dataset.monthLabels || 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec').split(/,\s*/);
      var skipDays = (this.dataset.daysToSkip || '').split(/,\s*/).filter(Boolean);
      var fmt = this.dataset.dateFormat || 'mm_dd';
      var add = function (n) {
        var d = new Date(); var left = n;
        while (left > 0) { d.setDate(d.getDate() + 1); var name = days[(d.getDay() + 6) % 7]; if (skipDays.indexOf(name) === -1) left--; }
        return d;
      };
      var label = function (d) {
        var m = months[d.getMonth()], day = d.getDate();
        return fmt === 'dd_mm' ? day + ' ' + m : m + ' ' + day;
      };
      this.querySelectorAll('[data-dynamic-date]').forEach(function (el) {
        var min = parseInt(el.dataset.minDays || '0', 10), max = parseInt(el.dataset.maxDays || '0', 10);
        el.innerHTML = (el.dataset.text || '').replace('[start_date]', label(add(min))).replace('[end_date]', label(add(max)));
      });
    }
  });

  /* ---------- minuteur ---------- */
  define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      var total = parseInt(this.dataset.duration || '0', 10);
      if (!total) return;
      var self = this, key = 'vd-countdown-' + total, end;
      try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + total * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
      var tick = function () {
        var s = Math.max(0, Math.round((end - Date.now()) / 1000));
        var mm = String(Math.floor(s / 60)).padStart(2, '0'), ss = String(s % 60).padStart(2, '0');
        var m = self.querySelector('[data-minutes], .countdown-timer__minutes'), c = self.querySelector('[data-seconds], .countdown-timer__seconds');
        if (m && c) { m.textContent = mm; c.textContent = ss; } else if (!self.children.length) self.textContent = mm + ':' + ss;
      };
      tick(); setInterval(tick, 1000);
    }
  });

  /* ---------- ajout au panier ---------- */
  define('product-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
    handleSubmit(evt) {
      if (evt) evt.preventDefault();
      var form = this.form, btn = this.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var err = this.querySelector('.product-form__error-message-wrapper'), errText = this.querySelector('.product-form__error-message');
      var spin = this.querySelector('.loading-overlay__spinner, .loading__spinner');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      if (spin) spin.classList.remove('hidden');
      var data = new FormData(form);
      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (r) {
          if (r.status) {
            if (err && errText) { errText.textContent = r.description || r.message; err.hidden = false; }
            return;
          }
          if (window.vdOpenCart) window.vdOpenCart();
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (e) { console.error(e); })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          if (spin) spin.classList.add('hidden');
        });
    }
  });

  /* ---------- barre d'achat collante ---------- */
  define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var section = this.dataset.section;
      var main = document.getElementById('ProductSubmitButton-' + section) || document.querySelector('.main-product-atc');
      var btn = this.querySelector('button[id^="SectionAtcBtn-"], button');
      if (btn && !btn.dataset.vdBound) {
        btn.dataset.vdBound = '1';
        btn.addEventListener('click', function (e) {
          var pf = document.querySelector('product-form[data-main="true"]');
          if (pf && pf.handleSubmit) { e.preventDefault(); pf.handleSubmit(e); }
        });
      }
      if (this.dataset.afterScroll !== 'true' || !main) return;
      this.style.transition = 'transform .3s ease';
      var show = function (on) { self.style.transform = on ? '' : 'translateY(110%)'; document.body.classList.toggle('sticky-atc-offset', on); };
      show(false);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { show(!e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(main);
    }
  });

  /* ---------- variantes ---------- */
  function variantsOf(root) {
    var s = root.querySelector('script[data-vd-variants], script[type="application/json"]');
    try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
  }
  function applyVariant(sectionId, v) {
    if (!v) return;
    document.querySelectorAll('form[id^="product-form-' + sectionId + '"] input[name="id"], #product-form-' + sectionId + ' input[name="id"]').forEach(function (i) { i.value = v.id; i.disabled = false; });
    document.querySelectorAll('#price-' + sectionId + ', #sticky-atc-' + sectionId).forEach(function (box) {
      box.querySelectorAll('.price').forEach(function (p) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        p.classList.toggle('price--on-sale', !!sale);
        p.classList.toggle('price--sold-out', !v.available);
        p.querySelectorAll('.price-item--regular:not(s), .price-item--sale').forEach(function (x) { x.textContent = money(v.price); });
        p.querySelectorAll('s.price-item--regular').forEach(function (x) { x.textContent = sale ? money(v.compare_at_price) : ''; });
        p.querySelectorAll('.badge__percentage-saved').forEach(function (x) { x.textContent = sale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; });
      });
    });
    var btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (btn) {
      if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', 'disabled');
      var lbl = btn.querySelector('.main-atc__label__text');
      if (lbl && window.variantStrings) lbl.textContent = v.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
    }
    document.querySelectorAll('#StickyAtcVariantPicker-' + sectionId + ' select').forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) { o.selected = String(o.dataset.variantId) === String(v.id); });
    });
    if (v.featured_media && window.vdGoToMedia) window.vdGoToMedia(sectionId, v.featured_media.id);
    try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
  }
  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects');
    if (vs) {
      var sectionId = vs.dataset.section;
      var opts = [];
      vs.querySelectorAll('.product-form__input').forEach(function (g) {
        var c = g.querySelector('input:checked'); var s = g.querySelector('select');
        opts.push(c ? c.value : s ? s.value : null);
      });
      vs.querySelectorAll('[data-vd-option-label]').forEach(function (l) { l.textContent = opts[Number(l.dataset.vdOptionLabel)] || ''; });
      var list = variantsOf(vs);
      var v = list.find(function (x) { return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); });
      applyVariant(sectionId, v);
      return;
    }
    var sv = e.target.closest && e.target.closest('secondary-variant-select');
    if (sv && e.target.tagName === 'SELECT') {
      var id = e.target.selectedOptions[0] && e.target.selectedOptions[0].dataset.variantId;
      var vlist = variantsOf(sv);
      var vv = vlist.find(function (x) { return String(x.id) === String(id); });
      var sid = sv.dataset.section;
      document.querySelectorAll('variant-selects[data-section="' + sid + '"]').forEach(function (vs2) {
        vv.options.forEach(function (val, i) {
          var g = vs2.querySelectorAll('.product-form__input')[i];
          if (!g) return;
          g.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === val; });
        });
        vs2.querySelectorAll('[data-vd-option-label]').forEach(function (l) { l.textContent = vv.options[Number(l.dataset.vdOptionLabel)] || ''; });
      });
      applyVariant(sid, vv);
    }
  });

  /* ---------- tiroir panier (simple) ---------- */
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var drawer = null;
  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'vd-cart';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="vd-cart__overlay" data-vd-close></div>' +
      '<aside class="vd-cart__panel" role="dialog" aria-modal="true" aria-label="Panier">' +
        '<header class="vd-cart__head"><span class="vd-cart__title">Panier</span>' +
        '<button type="button" class="vd-cart__x" data-vd-close aria-label="Fermer">&times;</button></header>' +
        '<div class="vd-cart__body"></div>' +
        '<footer class="vd-cart__foot"></footer>' +
      '</aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-vd-close]')) { closeCart(); return; }
      var b = e.target.closest('[data-vd-line]');
      if (b) changeLine(b.getAttribute('data-vd-line'), Number(b.getAttribute('data-vd-qty')));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    return drawer;
  }
  function render(cart) {
    var d = buildDrawer();
    var body = d.querySelector('.vd-cart__body'), foot = d.querySelector('.vd-cart__foot');
    d.querySelector('.vd-cart__title').textContent = 'Panier' + (cart.item_count ? ' (' + cart.item_count + ')' : '');
    if (!cart.item_count) {
      body.innerHTML = '<p class="vd-cart__empty">Votre panier est vide.</p>';
      foot.innerHTML = '<a class="vd-cart__btn" href="/collections/all">Continuer mes achats</a>';
    } else {
      body.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=160&') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="vd-cart__variant">' + esc(it.variant_title) + '</span>' : '';
        return '<div class="vd-cart__line">' +
          (img ? '<a href="' + esc(it.url) + '" class="vd-cart__img"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' : '<span class="vd-cart__img"></span>') +
          '<div class="vd-cart__info"><a href="' + esc(it.url) + '" class="vd-cart__name">' + esc(it.product_title) + '</a>' + variant +
            '<div class="vd-cart__row"><div class="vd-cart__qty">' +
              '<button type="button" data-vd-line="' + (i + 1) + '" data-vd-qty="' + (it.quantity - 1) + '" aria-label="Diminuer">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-vd-line="' + (i + 1) + '" data-vd-qty="' + (it.quantity + 1) + '" aria-label="Augmenter">+</button>' +
            '</div><span class="vd-cart__price">' + money(it.final_line_price) + '</span></div>' +
            '<button type="button" class="vd-cart__remove" data-vd-line="' + (i + 1) + '" data-vd-qty="0">Retirer</button>' +
          '</div></div>';
      }).join('');
      foot.innerHTML =
        '<div class="vd-cart__total"><span>Sous-total</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="vd-cart__note">Taxes incluses. Frais de livraison calculés à l’étape suivante.</p>' +
        '<a class="vd-cart__btn" href="/checkout">Commander</a>' +
        '<a class="vd-cart__link" href="/cart">Voir le panier</a>';
    }
    // bulle du panier dans l'en-tete
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) bubble.innerHTML = (cart.item_count ? '<div class="cart-count-bubble"><span aria-hidden="true">' + cart.item_count + '</span></div>' : '') + '<span class="visually-hidden">Panier</span>';
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openCart() {
    var d = buildDrawer();
    fetchCart().then(function (c) {
      render(c);
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vd-cart-open');
    });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vd-cart-open');
  }
  function changeLine(line, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(render);
  }
  window.vdOpenCart = openCart;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.header__icon--cart, a[href="/cart"].header__icon');
    if (!a || window.location.pathname === '/cart') return;
    e.preventDefault();
    openCart();
  });

  /* ---------- restes du theme d'origine : accordeon d'exemple "Collapsible row" ---------- */
  function dropPlaceholders() {
    document.querySelectorAll('.product__accordion').forEach(function (a) {
      var s = a.querySelector('summary');
      if (s && /Collapsible row/i.test(s.textContent)) a.remove();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dropPlaceholders); else dropPlaceholders();

  /* ---------- menu : lien de la page courante ---------- */
  function markActive() {
    var here = window.location.pathname.replace(/\/$/, '') || '/';
    var match = function (a) {
      var p; try { p = new URL(a.href, window.location.origin).pathname.replace(/\/$/, '') || '/'; } catch (e) { return false; }
      return p === '/' ? here === '/' : (here === p || here.indexOf(p + '/') === 0);
    };
    document.querySelectorAll('.header__inline-menu a.header__menu-item').forEach(function (a) {
      var span = a.querySelector('span');
      if (span && match(a)) { span.classList.add('header__active-menu-item-v2', 'color-accent-1'); a.setAttribute('aria-current', 'page'); }
    });
    document.querySelectorAll('.menu-drawer__menu a.menu-drawer__menu-item').forEach(function (a) {
      if (match(a)) { a.classList.add('menu-drawer__menu-item--active'); a.setAttribute('aria-current', 'page'); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markActive); else markActive();

  /* ---------- en-tete : bouton fermer du tiroir ---------- */
  document.addEventListener('click', function (e) {
    var close = e.target.closest && e.target.closest('.menu-drawer__close-menu-btn');
    if (!close) return;
    var d = close.closest('details');
    var hd = close.closest('header-drawer');
    // HeaderDrawer de Dawn ne ferme rien sans element a refocaliser
    if (hd && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(e, hd.querySelector('summary'));
    else if (d) d.removeAttribute('open');
  });
})();
